import I from '../types.ts';

const checkSmallMenu: I['checkSmallMenu'] = function (scrollTop) {
    return scrollTop > 30;
};

export default checkSmallMenu;
